module.exports = __webpack_public_path__ + "img/4.6e33edf5.jpg";